import type { FaireProductEntity } from "../../entity_types/product";

export const p_hemux84wb4: FaireProductEntity = {
  token: "p_hemux84wb4",
  type: "product",
  name: "Salchichón Ibérico",
  brandToken: "b_vbqxxxsbvs",
  brandName: "Mercado Famous",
  imageUrl:
    "https://cdn.faire.com/fastly/cf3d029fddf40977ac8029a1b4d1751644bf5d1fbcbd87bd3f80030c51cf513f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e04d6ac0fb4458a0f095e2270983647f5e3ce517bc3fd167ccfde58de5bc84a6.jpeg",
    "https://cdn.faire.com/fastly/58b52d25c32e22bacabb47c74dedf7817eed40d991035bbc57a4db1363c69533.jpeg",
    "https://cdn.faire.com/fastly/ad66faee8bf084e85c0642a7d25483eff689b2517759ebeb33a96e93cecc7101.jpeg",
    "https://cdn.faire.com/fastly/83ec4e520975dcd85b951df0ec8970e8d0f065ed9dd8875c9c426a010b69ccca.jpeg",
    "https://cdn.faire.com/fastly/38285ecccd6344c685360f61aca5966c271dde705950da00bb2f9c13071724ed.jpeg",
  ],
  priceDollars: 10.98,
  description:
    "Mercado Famous Salchichon Iberico is a crowdpleaser made from world-renowned Ibérico Pigs. It's the perfect meat for charcuterie, snacking, and sandwiches. We recommend pairing Mercado Famous Salchichon Iberico with sauvignon blanc & sheep’s milk cheese. \n\nSalchichon Iberico is a cured sausage and seasoned with nutmeg, black and white pepper, then cured for 40 days in Spain. Our product comes from a century old family farm in Salamanca, Spain. Our pigs roam free across a protected reservation  of meadow and forrest, and are fed on acorns, natural pastures and other organic foods. We believe happy pigs = happy meats. \n\nSalchichon Iberico comes pre sliced, vacuum sealed and ready to eat. It is shelf stable, and does not require refrigeration util opened. One pack contains 2 servings of Salchichon Iberico. \n\nIngredients:Pork meat, salt, nutmeg, black pepper, white pepper, seasoning (dextrin, dextrose, potassium nitrate, sodium nitrite, trisodium citrate)\nGluten Free, Lactose Free, Organic",
  tags: [],
  msrpDollars: 21.96,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T05:28:17.313Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
